import { InfoCardIllustrative, Steps } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { Step } from 'app/blocks/sections/Steps/model'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export interface IAttributes
  extends Omit<React.ComponentProps<typeof Steps>, 'disclaimer' | 'callToCation' | 'secondaryCallToAction'>,
    ICTAAttributes {
  disclaimer: string
  steps: Step[]
}

const StepsBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const { callToAction, secondaryCallToAction } = useCTAAttributes(attributes)

  return (
    <Steps
      title={attributes.title}
      subtitle={attributes.subtitle}
      background={attributes?.background ?? 'white'}
      disclaimer={attributes?.disclaimer ? parse(attributes?.disclaimer) : undefined}
      callToAction={callToAction}
      secondaryCallToAction={secondaryCallToAction}
    >
      {attributes.steps.map((step, index) => (
        <InfoCardIllustrative
          key={index}
          icon={<LazyLoadImage src={step.mediaUrl} alt="" width="100%" height="100%" />}
          title={step.title}
          body={parse(step.body ?? '')}
        />
      ))}
    </Steps>
  )
}

export default StepsBlock
